// extracted by mini-css-extract-plugin
export default {"bottonContainer":"styles_bottonContainer__oS+qb","button":"styles_button__+XlG9","cancel":"styles_cancel__OrZMq"};